export const environment = {
  production: true,
  apiUrl: 'https://autogestionbackend.nobis.com.ar/',
  gecrosUrl: 'https://appmobile.nobissalud.com.ar/',
  meiliSearchUrl: 'https://meilisearch.nobis.com.ar/',
  meiliSearchKey: '6e0dde29c46d4a2fbdecc25913b21f59ce631ae46b1740d82b4ebf2f39dbb948',
  meiliSearchIndex: 'nobis-medical-providers',
  meiliSearchStudiesIndex: 'nobis-medical-studies',
  firebase: {
    apiKey: 'AIzaSyB5FItiMLPeue1rh2dRITwGYXAFGHT8sDI',
    authDomain: 'app-nobis-509515.firebaseapp.com',
    projectId: 'app-nobis-509515',
    storageBucket: 'app-nobis-509515.firebasestorage.app',
    messagingSenderId: '891941143224',
    appId: '1:891941143224:web:a733ccb0111e0f13d4ea4d',
    measurementId: 'G-V8TEPS023X',
  },
  // Opcional: vacío usa la clave pública por defecto de Firebase. Si se completa, debe ser la del proyecto de arriba.
  firebaseVapidKey: '',
};
